<div class="step-wrapper">
    <span *ngIf="stepStaus !== StepStaus.COMPLETE" class="step-btn-warpper btn-circle">{{title}}</span>
    <span *ngIf="stepStaus === StepStaus.COMPLETE" class="step-btn-warpper btn-complite complite-icon"></span>
</div>